export const API_URL = process.env.REACT_APP_API_URL
export const USER_API_URL = `${API_URL}/Usuario`
export const CLIENT_API_URL = `${API_URL}/Cliente`
export const PAYMENT_METHOD_API_URL = `${API_URL}/FormaPagamento`
export const NOTIFICATIONS_API_URL = `${API_URL}/Notificacao`
export const ORDER_API_URL = `${API_URL}/Pedido`
export const PRODUCT_API_URL = `${API_URL}/Produto`
export const SCHEDULE_EVENTS_API_URL = `${API_URL}/Agendamento`
export const REPORTS_API_URL = `${API_URL}/Relatorio`
export const ADDRESS_API_URL = `${API_URL}/Endereco`
export const COMISSIONER_API_URL = `${API_URL}/Comissionado`
export const FACTORY_API_URL = `${API_URL}/Fabrica`
export const COMPANY_API_URL = `${API_URL}/Empresa`
export const LICENSE_API_URL = `${API_URL}/Licenca`
export const RENOVACAO_API_URL = `${API_URL}/Renovacao`
export const BUDGET_MANAGEMENT_API_URL = `${API_URL}/Financeiro`
